import React, { useEffect, useState } from 'react';
export interface Props {
  action: 'show' | 'hide';
  delay: number;
  onComplete?: () => void;
  children: React.ReactNode;
}

export const Delayed: React.FC<Props> = ({
  action,
  delay,
  children,
  onComplete,
}) => {
  const [isVisible, setIsVisible] = useState(action === 'show' ? false : true);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsVisible(action === 'show' ? true : false);
      onComplete && onComplete();
    }, delay);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [action, delay, onComplete]);
  if (!isVisible) {
    return null;
  }
  return <>{children}</>;
};
Delayed.displayName = 'Delayed';

export default Delayed;
